import * as yup from 'yup';
import { fieldSchema } from '~validation';
var formMailingListSignupSchema = yup.object().shape({
  emailAddressMailingList: fieldSchema.email.required()
});
export default formMailingListSignupSchema;